import {
  HealthConfig,
  HealthStatus,
  LoanSummaryData,
} from '@swyftx/features/loans/components/LoanHealth/api/types/loanHealth.types';

export const BASE_GAUGE_DATA = [
  { label: 'Section1', value: 65 },
  { label: 'Section2', value: 15 },
  { label: 'Section3', value: 15 },
  { label: 'Section4', value: 15 },
];

export const BASE_HEALTH_PERCENTAGES: Record<HealthStatus, number> = {
  [HealthStatus.Inactive]: 0,
  [HealthStatus.Healthy]: 10,
  [HealthStatus.Attention]: 50,
  [HealthStatus.Repayment]: 55,
  [HealthStatus.Default]: 60,
};

export const HEALTH_STATUS_CONFIG: Record<HealthStatus, HealthConfig> = {
  [HealthStatus.Inactive]: {
    status: HealthStatus.Inactive,
    pathFillColor: '',
    textColor: 'secondary',
  },
  [HealthStatus.Healthy]: {
    status: HealthStatus.Healthy,
    statusTitle: 'loanHealth.loanHealthGauge.statusTitle.healthy',
    pathFillColor: 'var(--color-background-success)',
    textColor: 'success',
    chipColor: 'success',
    chipText: 'loanHealth.loanHealthGauge.chipText.healthy',
  },
  [HealthStatus.Attention]: {
    status: HealthStatus.Attention,
    statusTitle: 'loanHealth.loanHealthGauge.statusTitle.attention',
    pathFillColor: 'var(--color-background-info)',
    textColor: 'info',
    chipColor: 'info',
    chipText: 'loanHealth.loanHealthGauge.chipText.attention',
  },
  [HealthStatus.Repayment]: {
    status: HealthStatus.Repayment,
    statusTitle: 'loanHealth.loanHealthGauge.statusTitle.repayment',
    pathFillColor: 'var(--color-background-warning)',
    textColor: 'warning',
    chipColor: 'warning',
    chipText: 'loanHealth.loanHealthGauge.chipText.repayment',
  },
  [HealthStatus.Default]: {
    status: HealthStatus.Default,
    statusTitle: 'loanHealth.loanHealthGauge.statusTitle.default',
    pathFillColor: 'var(--color-background-error)',
    textColor: 'error',
    chipColor: 'destructive',
    chipText: 'loanHealth.loanHealthGauge.chipText.default',
  },
};

export const LOAN_SUMMARY_DATA: Partial<Record<HealthStatus, LoanSummaryData>> = {
  [HealthStatus.Healthy]: {
    percentage: BASE_HEALTH_PERCENTAGES[HealthStatus.Healthy], // 45
    btcPriceSecurityValue: 'loanHealth.loanSummaryData.healthy.btcPriceSecurityValue',
    lvrTitle: 'loanHealth.loanSummaryData.healthy.title',
    lvrDescription: 'loanHealth.loanSummaryData.healthy.description',
    lvr: 'loanHealth.loanSummaryData.healthy.lvr',
    cardSeverity: 'success',
  },
  [HealthStatus.Attention]: {
    percentage: BASE_HEALTH_PERCENTAGES[HealthStatus.Attention], // 50
    btcPriceSecurityValue: 'loanHealth.loanSummaryData.attention.btcPriceSecurityValue',
    lvrTitle: 'loanHealth.loanSummaryData.attention.title',
    lvrDescription: 'loanHealth.loanSummaryData.attention.description',
    lvr: 'loanHealth.loanSummaryData.attention.lvr',
    cardSeverity: 'info',
  },
  [HealthStatus.Repayment]: {
    percentage: BASE_HEALTH_PERCENTAGES[HealthStatus.Repayment], // 55
    btcPriceSecurityValue: 'loanHealth.loanSummaryData.repayment.btcPriceSecurityValue',
    lvrTitle: 'loanHealth.loanSummaryData.repayment.title',
    lvrDescription: 'loanHealth.loanSummaryData.repayment.description',
    lvr: 'loanHealth.loanSummaryData.repayment.lvr',
    cardSeverity: 'warning',
  },
  [HealthStatus.Default]: {
    percentage: BASE_HEALTH_PERCENTAGES[HealthStatus.Default], // 60
    btcPriceSecurityValue: 'loanHealth.loanSummaryData.default.btcPriceSecurityValue',
    lvrTitle: 'loanHealth.loanSummaryData.default.title',
    lvrDescription: 'loanHealth.loanSummaryData.default.description',
    lvr: 'loanHealth.loanSummaryData.default.lvr',
    cardSeverity: 'destructive',
  },
};
